import { create } from 'zustand';
import type { PosCategoryTab } from '@/lib/api/stores.js';

export type PosRepairStep = 'makes' | 'models' | 'services';

type PosUiState = {
  activeCategory: PosCategoryTab | 'all';
  repairStep: PosRepairStep;
  selectedMake: { id: string; name: string } | null;
  selectedModel: { id: string; name: string } | null;
  setActiveCategory: (category: PosCategoryTab | 'all') => void;
  resetRepairsNav: () => void;
  selectMake: (make: { id: string; name: string }) => void;
  selectModel: (model: { id: string; name: string }) => void;
  goToRepairMakes: () => void;
};

export const usePosUiStore = create<PosUiState>((set) => ({
  activeCategory: 'all',
  repairStep: 'makes',
  selectedMake: null,
  selectedModel: null,
  setActiveCategory: (activeCategory) =>
    set({
      activeCategory,
      repairStep: 'makes',
      selectedMake: null,
      selectedModel: null,
    }),
  resetRepairsNav: () =>
    set({ repairStep: 'makes', selectedMake: null, selectedModel: null }),
  selectMake: (selectedMake) => set({ selectedMake, repairStep: 'models', selectedModel: null }),
  selectModel: (selectedModel) => set({ selectedModel, repairStep: 'services' }),
  goToRepairMakes: () => set({ repairStep: 'makes', selectedMake: null, selectedModel: null }),
}));
